export default function Settings() {
  return <h2>Settings Page</h2>;
}
